import { BaseEntity } from '../base-entity';

export interface DonorInstitutionEntity extends BaseEntity {
  id: number;
  name: string;
  taxExemptId: string | null;
  primaryEmail: string | null;
  phone: string | null;
  website: string | null;
  addressLine1: string | null;
  city: string | null;
  country: string;
}

export interface CreateDonorInstitutionDto {
  name: string;
  taxExemptId?: string | null;
  primaryEmail?: string | null;
  phone?: string | null;
  website?: string | null;
  addressLine1?: string | null;
  city?: string | null;
  country: string;
}

export interface UpdateDonorInstitutionDto {
  name?: string;
  taxExemptId?: string | null;
  primaryEmail?: string | null;
  phone?: string | null;
  website?: string | null;
  addressLine1?: string | null;
  city?: string | null;
  country?: string;
}

export interface CreateDonationDto {
  amount: number;
  currency?: string;
  purpose?: string | null;
  paymentMethod?: 'bank_transfer' | 'check' | 'credit_card' | null;
  paymentDate: Date;
  notes?: string | null;
}

export enum DonationStatus {
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  CANCELLED = 'cancelled',
}

export interface DonationEntity extends BaseEntity {
  id: number;
  donationNumber: string;
  donorId: number;
  amount: number;
  currency: string;
  purpose: string | null;
  paymentMethod: string | null;
  paymentDate: Date;
  status: DonationStatus;
  notes: string | null;
}

export interface DonationReceiptEntity extends BaseEntity {
  id: number;
  receiptNumber: string;
  donationId: number;
  amount: number;
  isCancellation: boolean;
  cancelsReceiptId: number | null;
  fileUrl: string | null;
}

export interface DonationWithReceipts extends DonationEntity {
  receipts: DonationReceiptEntity[];
}

export interface DonorInstitutionWithDonations extends DonorInstitutionEntity {
  donations: DonationWithReceipts[];
}
